import { frontendURL } from '../../../helper/URLHelper';
import { FEATURE_FLAGS } from '../../../featureFlags';
import OnboardingHome from './OnboardingHome.vue';

const meta = {
  featureFlag: FEATURE_FLAGS.ONBOARDING,
  permissions: ['administrator'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/onboarding'),
    name: 'onboarding_home',
    component: OnboardingHome,
    meta,
  },
];
